import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants, SidenavService } from '@modeso/aumico-lib-core-fe';
import { onMainContentChange } from '@modeso/aumico-lib-core-fe/layout/animations/animations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';

@UntilDestroy()
@Component({
    selector: 'ham-side-bar',
    templateUrl: 'ham-side-bar.component.html',
    styleUrls: ['./ham-side-bar.component.scss'],
    animations: [onMainContentChange],
})
export class HamSideBarComponent implements OnInit {
    
    @Input() opened: boolean = true;
    @Output() sideNavStateChanged = new EventEmitter<boolean>();

    public sideNavState = true;

    constructor(private sidenavService: SidenavService, private localStorageService: LocalStorageService) {}

    ngOnInit(): void {
        this.checkAndSwitchSidebar();
        this.sidenavService.sideNavState$.pipe(untilDestroyed(this)).subscribe((res) => {
            this.sideNavState = res;
            this.opened = res;
            this.sideNavStateChanged.emit(this.opened);
            if (this.sideNavState) {
                this.localStorageService.setSideNavCollapsedKey('1');
            } else {
                this.localStorageService.setSideNavCollapsedKey('0');
            }
        });
    }

    private checkAndSwitchSidebar(): void {
        if (this.localStorageService.isKeyInLocalStorage(Constants.SIDE_NAV_STATE_COLLAPSED_KEY)) {
            const sidebarStatus = this.localStorageService.getItem(Constants.SIDE_NAV_STATE_COLLAPSED_KEY);
            const value = Boolean(Number(sidebarStatus));
            this.sideNavState = value;
            this.sidenavService.sideNavState$.next(value);
        }
    }

    public toggleSidebar(): void {
        this.opened = !this.opened;

        this.sideNavState = !this.sideNavState;
        this.sidenavService.sideNavState$.next(this.sideNavState);

        this.sideNavStateChanged.emit(this.opened);
    }
}
